import { useSyncExternalStore } from 'react';

const listeners = new Set<() => void>();

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// The head block in index.html decides whether a visitor is asked on load.
const isOpen = (): boolean => window.CORETAS_CONSENT_PROMPT === true;

const setOpen = (open: boolean): void => {
  window.CORETAS_CONSENT_PROMPT = open;
  for (const listener of listeners) listener();
};

export const openConsentPrompt = (): void => setOpen(true);

export const closeConsentPrompt = (): void => setOpen(false);

export const useConsentPrompt = (): boolean =>
  useSyncExternalStore(subscribe, isOpen, () => false);
